export const environmentShared = {
    staticMetricsConfiguration: false,
    supportedLocales: [
        { localeId: 'en', countryPrefix: 'GB' },
        { localeId: 'pt', countryPrefix: 'PT' },
    ],
    multifactorConfig: {
        PLATFORM_BASE_URL: 'api/authentication/',
        SEND_CODE_ROUTE: (url: string) => {
            return url + 'send-code';
        },
        VALIDATE_CODE_ROUTE: (url: string) => {
            return url + 'validate-code';
        },
    },
    scheduleConfig: {
        PLATFORM_BASE_URL: 'platform-api/healthcareproxy/',
        TENANT_FEATURES_ROUTE: (url: string) => {
            return url + 'tenant-features';
        },
        ACTS_ROUTE: (url: string) => {
            return url + 'acts';
        },
        EFRS_ROUTE: (url: string) => {
            return url + 'conventions';
        },
        FACILITIES_ROUTE: (url: string) => {
            return url + 'facilities';
        },
        FACILITIES_NEAREST_ROUTE: (url: string) => {
            return url + 'facilities-nearest';
        },
        PATIENTS_FISCAL_NUMBER_ROUTE: (url: string) => {
            return url + 'patients';
        },
        PATIENTS_PHONE_NUMBER_ROUTE: (url: string) => {
            return url + 'patients-phone-number';
        },
        PATIENTS_HISTORY_ROUTE: (url: string) => {
            return url + 'appointments-patient-history';
        },
        PATIENTS_CANCEL_ROUTE: (url: string) => {
            return url + 'appointments-cancelled';
        },
        PATIENTS_RESCHEDULE_ROUTE: (url: string) => {
            return url + 'appointments-rescheduled';
        },
        PHYSICIANS_ROUTE: (url: string) => {
            return url + 'providers';
        },
        SCHEDULE_SLOT_ROUTE: (url: string) => {
            return url + 'slots-scheduled';
        },
        SLOTS_ROUTE: (url: string) => {
            return url + 'slots';
        },
        SLOTS_NEAREST_ROUTE: (url: string) => {
            return url + 'slots-nearby-facilities';
        },
        SLOT_VALIDATION_ROUTE: (url: string) => {
            return url + 'slot-relations';
        },
        ACT: 'ActId',
        ACT_TYPE: 'ActType',
        APPOINTMENTS_HISTORY_YEAR_LENGTH: 1,
        EFR: 'ConventionId',
        END_DATE: 'EndDate',
        FACILITY: 'HealthcareFacilityId',
        LOCALE: 'Language',
        PATIENT_FISCAL_NUMBER_IDENTIFICATION: 'PatientIdentification',
        PATIENT_PHONE_NUMBER_IDENTIFICATION: 'PhoneNumber',
        PATIENT: 'ClientCode',
        PHYSICIAN: 'HealthcareProviderId',
        START_DATE: 'StartDate',
    },
    outboundsConfig: {
        POLLING_INTERVAL: 300,
        POLLING_INTERVAL_TESTS: 20,
        POLLING_INTERVAL_OUTBOUNDS: 180,
        PLATFORM_BASE_URL: 'platform-api/api/v1/',
        CAMPAIGNS_ROUTE: (url: string) => {
            return `${url}campaigns`;
        },
        CAMPAIGNS_DETAILS_ROUTE: (url: string, campaignId: string) => {
            return `${url}campaigns/${campaignId}`;
        },
        CAMPAIGN_OUTBOUND_REQUESTS_DETAILS_ROUTE: (url: string) => {
            return `${url}campaigns/outbound-requests`;
        },
        CREATE_CONTACT_FILES_ROUTE: (url: string) => {
            return `${url}campaigns/contact-files`;
        },
        DISABLED_ROUTE: (url: string, campaignId: string) => {
            return `${url}campaigns/disabled/${campaignId}`;
        },
        ENABLED_ROUTE: (url: string, campaignId: string) => {
            return `${url}campaigns/enabled/${campaignId}`;
        },
        EDIT_CAMPAIGN_ROUTE: (url: string, campaignId: string) => {
            return `${url}campaigns/${campaignId}`;
        },
        DELETE_CAMPAIGN_ROUTE: (url: string, campaignId: string) => {
            return `${url}campaigns/${campaignId}`;
        },
        TRIGGER_CAMPAIGN_ROUTE: (url: string) => {
            return `${url}campaigns/started`;
        },
        CREATE_OUTBOUND_ROUTE: (url: string) => {
            return `${url}campaigns/outbound-requests`;
        },
        CREATE_TEST_OUTBOUND_ROUTE: (url: string) => {
            return `${url}campaigns/testing-outbound-requests`;
        },
        EDIT_OUTBOUND_ROUTE: (url: string, outboundRequestId: string) => {
            return `${url}campaigns/outbound-requests/${outboundRequestId}`;
        },
        DELETE_OUTBOUND_ROUTE: (url: string, outboundRequestId: string) => {
            return `${url}campaigns/outbound-requests/${outboundRequestId}`;
        },
        TRIGGER_OUTBOUND_ROUTE: (url: string) => {
            return `${url}campaigns/started-outbound-requests`;
        },
        ESTIMATE_CAMPAIGN_ROUTE: (url: string) => {
            return `${url}campaigns/estimation`;
        },
    },
    promptRepliesConfig: {
        POLLING_INTERVAL: 3600,
        PLATFORM_BASE_URL: 'platform-api/api/v1/',
        CREATE_PROMPT_REPLY: (url: string) => {
            return `${url}prompt-replies`;
        },
        PROMPT_REPLIES: (url: string) => {
            return `${url}prompt-replies`;
        },
        PROMPT_REPLIES_DETAILS: (url: string, promptReplyId: string) => {
            return `${url}prompt-replies/${promptReplyId}`;
        },
        DELETE_PROMPT_REPLY: (url: string, promptReplyId: string) => {
            return `${url}prompt-replies/${promptReplyId}`;
        },
        UPDATE_PROMPT_REPLY: (url: string, promptReplyId: string) => {
            return `${url}prompt-replies/${promptReplyId}`;
        },
        CREATE_PROMPT_REPLY_ENTRIES: (url: string, promptReplyId: string) => {
            return `${url}prompt-replies/${promptReplyId}/entries`;
        },
        DELETE_PROMPT_REPLY_ENTRY: (url: string, promptReplyEntryId: string) => {
            return `${url}prompt-replies/entries/${promptReplyEntryId}`;
        },
        UPDATE_PROMPT_REPLY_ENTRY: (url: string, promptReplyEntryId: string) => {
            return `${url}prompt-replies/entries/${promptReplyEntryId}`;
        },
    },
    skillsConfig: {
        PLATFORM_BASE_URL: 'platform-api/api/v1/',
        GROUPINGS_ROUTE: (url: string) => {
            return url + 'groupings';
        },
        TAGS_ROUTE: (url: string) => {
            return url + 'tags';
        },
        SKILLS_TAGS_ROUTE: (url: string) => {
            return url + 'skills-tags';
        },
        SKILLS_ROUTE: (url: string) => {
            return url + 'skills';
        },
        SPEECH_ROUTE: (url: string) => {
            return url + 'speech';
        },
        SPEECH_DRAFT_ROUTE: (url: string) => {
            return url + 'speech-draft';
        },
        SPEECH_CHANGES_ROUTE: (url: string) => {
            return url + 'speech-changes';
        },
        SPEECH_DRAFT_CHANGES_ROUTE: (url: string) => {
            return url + 'speech-draft-changes';
        },
        SPEECH_PUBLISH_ROUTE: (url: string) => {
            return url + 'speech-publications';
        },
        SPEECH_SPECS_ROUTE: (url: string) => {
            return url + 'speech-specs';
        },
        DIMENSIONS_ROUTE: (url: string) => {
            return url + 'speech-dimensions';
        },
        CHANNEL_DIMENSION_ROUTE: (url: string) => {
            return url + 'channels';
        },
        FACILITY_DIMENSION_ROUTE: (url: string) => {
            return url + 'facilities';
        },
        LANGUAGE_DIMENSION_ROUTE: (url: string) => {
            return url + 'languages';
        },
        PERSONA_DIMENSION_ROUTE: (url: string) => {
            return url + 'personas';
        },
        refreshInterval: 120,
        retryPolicy: {
            numberOfRetries: 3,
            scaling: 100,
            statusCodes: [500, 400, 401, 404, 403],
        },
        channelIconMap: {
            facebook: 'ag-icon-facebook-messenger',
            whatsapp: 'ag-icon-whatsapp',
            email: 'ag-icon-email',
            instagram: 'ag-icon-instagram',
            voice: 'ag-icon-call',
            phone: 'ag-icon-call',
            sms: 'ag-icon-sms',
            widget: 'ag-icon-alice-widget-desktop',
            cgdWidget: 'ag-icon-alice-widget',
            webWidget: 'ag-icon-alice-widget-desktop',
            'web-widget': 'ag-icon-alice-widget-desktop',
        },
    },
    operatorAvailableStatuses: 'available',
    operatorAvailableOutboundStatuses: 'availableOutbound',
    operatorLoggedInStatuses: 'loggedIn',
    operatorLoggedOutStatuses: 'loggedOut',
    operatorUnavailableStatuses: 'unavailable'
};
